module.exports = __webpack_public_path__ + "public/img/header2.34c4b4e9.png";